import React from 'react';
import { motion } from 'framer-motion';

interface StatsCardProps {
  title: string;
  value: string;
  icon: string;
  color: string;
  index: number;
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon, color, index }) => {
  return (
    <motion.div 
      className="flex flex-col gap-2 rounded-xl p-4 bg-white dark:bg-gray-800/30 border border-gray-200 dark:border-gray-700/50 card hover-lift cursor-pointer"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 + index * 0.1, duration: 0.5, type: "spring", stiffness: 400, damping: 10 }}
      whileHover={{ scale: 1.02, y: -2 }}
    >
      <motion.div 
        className="flex items-center justify-between"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7 + index * 0.1 }}
      >
        <motion.p 
          className="text-sm font-medium text-gray-500 dark:text-gray-400"
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.8 + index * 0.1 }}
        >
          {title}
        </motion.p>
        <motion.span 
          className="material-symbols-outlined text-lg text-gray-400 bounce-light"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.9 + index * 0.1, type: "spring", stiffness: 500, damping: 30 }}
        >
          {icon}
        </motion.span>
      </motion.div>
      
      <motion.p 
        className={`text-3xl font-bold ${color}`}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1 + index * 0.1, type: "spring", stiffness: 500, damping: 30 }}
      >
        {value}
      </motion.p>
    </motion.div>
  );
};

export default StatsCard;